
<template>
    <div ref="mediaCarousel">
        <swiper class="swiper media-carousel"
                :options="swiperOption">
            <swiper-slide class="card"
                          ref="card"
                          v-for="(item, index) in agentMedias"
                          :key="index"
                          v-b-modal.modal-yt>
                <div class=" d-flex justify-content-center align-items-center img"
                     :class="{'hoverIn': item.mouseover,'hoverOut': item.mouseout}"
                     :style="{'background-image': `url(${item.imgUrl})`}"
                     :data-ga-element="item.gaStr"
                     @click.prevent="showMedia(item)"
                     @mouseover="setHover('mouseover', item)"
                     @mouseout="setHover('mouseout', item)">
                    <div class="triangle" :data-ga-element="item.gaStr"/>
                    <p class="title d-none d-md-block" :data-ga-element="item.gaStr">{{item.title}}</p>
                </div>
            </swiper-slide>
            <div class="swiper-pagination"
                 slot="pagination"></div>
            <div class="swiper-button-prev d-none d-md-block"
                 slot="button-prev"></div>
            <div class="swiper-button-next d-none d-md-block"
                 slot="button-next"></div>
        </swiper>
        <b-modal id="modal-yt"
                 size="lg"
                 hide-header
                 hide-footer>
            <template #default="{ close }">
                <b-button-close size="lg"
                                @click="close()" />
                <div class="d-flex justify-content-center py-2 w-100">
                    <iframe id="ytplayer"
                            class="w-100"
                            :style="{'height': `${modalMediaHeight}px`}"
                            type="text/html"
                            :src="youtubeLink.mediaUrl"
                            frameborder="0"
                            allowfullscreen
                            :data-ga-element="youtubeLink.gaStr" />
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
// import 'swiper/css/swiper.css'
export default {
    name: 'swiper-example-loop-group',
    title: 'Loop mode with multiple slides per group',
    components: {
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            ytHeight: 0,
            modalMediaWidth: 0,
            modalMediaHeight: 0,
            agentMedias: [
                {
                    imgUrl: require('../../assets/images/home/agentMedia/agent1.png'),
                    mediaUrl: 'https://www.youtube.com/embed/fNAr_lMDvHs',
                    title: '業務職人 彭士軒',
                    gaStr: '新保險網站_影片業務職人彭士軒',
                    mouseover: false,
                    mouseout: false,
                },
                {
                    imgUrl: require('../../assets/images/home/agentMedia/agent2.png'),
                    mediaUrl: 'https://www.youtube.com/embed/CK2qr7VybLA',
                    title: '業務職人 李鎬年',
                    gaStr: '新保險網站_業務職人李鎬年',
                    mouseover: false,
                    mouseout: false,
                },
                {
                    imgUrl: require('../../assets/images/home/agentMedia/agent3.png'),
                    mediaUrl: 'https://www.youtube.com/embed/fzFLKH9MQKo',
                    title: '業務職人 蔡淑貞 & 吳國川',
                    gaStr: '新保險網站_業務職人蔡淑貞',
                    mouseover: false,
                    mouseout: false,
                },
            ],
            swiperOption: {
                // slidesPerView: 3,
                // spaceBetween: 0,
                // slidesPerGroup: 3,
                slidesPerView: 1.65,
                spaceBetween: 18,
                centeredSlides: true,
                slidesPerGroup: 1,
                loop: true,
                // loopFillGroupWithBlank: true,
                direction: 'horizontal',
                breakpoints: {
                    320: {
                        slidesPerView: 1.65,
                        spaceBetween: 18,
                        centeredSlides: true,
                        slidesPerGroup: 1,
                    },
                    992: {
                        slidesPerView: 1.65,
                        spaceBetween: 18,
                        centeredSlides: true,
                        slidesPerGroup: 1,
                    },
                    // 576: {
                    //     slidesPerView: 3,
                    //     spaceBetween: 0,
                    //     slidesPerGroup: 3,
                    //     centeredSlides: false,
                    // },
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
        };
    },
    mounted() {
        window.addEventListener('resize', this.resizeHandler);
        this.resizeHandler();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
    },
    methods: {
        setHover(active, item) {
            this.agentMedias.map((item) => {
                item.mouseover = false;
                item.mouseout = false;
            });
            item[active] = true;
        },
        showMedia(media) {
            this.youtubeLink = Object.assign(media);
        },
        resizeHandler() {
            const windowWidth = document.body.offsetWidth;
            this.modalMediaHeight = windowWidth * 0.8 > 700 ? 393 : windowWidth * 0.8 * 0.565;
        },
    },
};
</script>

<style lang="scss" scoped>
.carousel {
    margin: auto;
    width: 100%;
}
.card {
    border: 0;
    border-radius: 0;
    margin-bottom: 30px;
    margin-top: 0px;
    height: 30vw;
    max-height: 30vw;
    outline: 0;

    @include media-breakpoint-up(sm) {
    }
    @include media-breakpoint-up(md) {
        height: 14vw;
        max-height: 14vw;
        &:nth-child(3n + 1) {
            padding: 0 20px;
        }
        &:nth-child(3n + 2) {
            padding: 0 20px;
        }
        &:nth-child(3n + 3) {
            padding: 0 20px;
        }
    }
    .img {
        height: 30vw;
        max-height: 30vw;
        width: 100%;
        cursor: pointer;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 105%;
        position: relative;
        @include media-breakpoint-up(md) {
            height: 14vw;
            max-height: 14vw;
        }
        &.hoverIn {
            animation: scale 0.25s linear forwards;
        }
        &.hoverOut {
            animation: scale2 0.25s reverse linear forwards;
        }
        @keyframes scale {
            from {
                filter: contrast(1);
                background-size: 105%;
            }
            to {
                filter: contrast(1.25);
                background-size: 120%;
            }
        }
        @keyframes scale2 {
            from {
                filter: contrast(1);
                background-size: 105%;
            }
            to {
                filter: contrast(1.25);
                background-size: 120%;
            }
        }
    }
    .title {
        font-size: 0.875rem;
        letter-spacing: 0.5px;
        margin: 0;
        position: absolute;
        color: #fff;
        position: absolute;
        bottom: 8px;
        right: 8px;
        text-shadow: 0px 2px 4px #000000ce;
        @include media-breakpoint-up(lg) {
            font-size: 1rem;
            bottom: 10px;
            right: 10px;
        }
    }
    .triangle {
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 3.6vw 0 3.6vw 6.4vw;
        border-color: transparent transparent transparent #ffffff;
        opacity: 0.65;
        @include media-breakpoint-up(sm) {
            // border-width: 2.5vw 0 2.5vw 4.2vw;
        }
        @include media-breakpoint-up(lg) {
            border-width: 25px 0 25px 41px;
        }
    }
}
::v-deep {
    .swiper-slide:focus {
        border: 0;
    }
    .swiper-button-prev:after,
    .swiper-button-next:after {
        font-size: 2rem;
    }
    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-container-horizontal > .swiper-pagination-bullets {
        bottom: -4px;
    }
    .swiper-button-next,
    .swiper-container-rtl .swiper-button-prev {
        right: 0px;
    }
    .swiper-pagination-bullet {
        width: 10px;
        height: 10px;
        border: 1px solid #dddddd;
        background-color: $white;
        opacity: 1;
    }
    .swiper-pagination-bullet-active {
        background-color: #0089d1;
    }
}

::v-deep .modal-dialog {
    width: 80% !important;
    max-width: 700px !important;
    margin: auto;
}
::v-deep .modal-content {
    background-color: transparent;
    border: 0;
    max-width: 700px !important;
    .modal-body {
        padding: 1rem 0;
    }
    .close {
        font-size: 2.5rem;
        font-weight: 100;
        color: #fff;
        opacity: 1;
        position: absolute;
        right: -26px;
        line-height: 0.65;
    }
}
</style>
